import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const ParkNumberCellContent: React.FC<ParkNumberCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => item.parkNumber ?? "", [item.parkNumber]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ParkNumberCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default ParkNumberCellContent;
